export const ORDERED_OPTION_KEYS = ['A', 'B', 'C', 'D', 'E'];

export const getOrderedOptionEntries = (options = {}) => {
    if (!options || typeof options !== 'object') {
        return [];
    }

    const knownEntries = ORDERED_OPTION_KEYS
        .filter((key) => Object.prototype.hasOwnProperty.call(options, key))
        .map((key) => [key, options[key]]);
    const extraEntries = Object.keys(options)
        .filter((key) => !ORDERED_OPTION_KEYS.includes(key))
        .sort()
        .map((key) => [key, options[key]]);

    return [...knownEntries, ...extraEntries];
};

export const READING_TASK_LABELS = {
    single_passage: 'Shared Passage',
    poem: 'Poem',
    paired_extract: 'Paired Extracts',
    multi_extract: 'Multiple Extracts',
    cloze: 'Cloze Passage',
    sentence_insertion: 'Sentence Insertion',
    heading_matching: 'Heading Matching',
};

export const getReadingTaskLabel = (readingTaskType) => (
    READING_TASK_LABELS[readingTaskType] || READING_TASK_LABELS.single_passage
);
